import { ReactComponent as DownloadIcon } from "../../assets/img/download.svg";
import { educator } from "../../assets/text/educator";

const EducatorKitArabicMobileScreen = () => {
  return (
    <div className="educator-mobilescreen-arabic">
      <div className="educator-mobilescreen-arabic-container">
        {educator.arabic.text.map((text, textIndex) => {
          let parts = text.split(/\*\*/g);
          return (
            <div style={{ marginBottom: "5%" }}>
              {parts.map((part, partIndex) => {
                if (partIndex % 2 === 0 && part) {
                  return (
                    <span
                      className="educator-mobilescreen-arabic-text"
                      key={partIndex}
                    >
                      {part}
                    </span>
                  );
                } else if (part) {
                  return (
                    <span
                      className="educator-mobilescreen-arabic-text-heading"
                      key={partIndex}
                    >
                      {part}
                    </span>
                  );
                }
              })}
            </div>
          );
        })}
        <a
          href="pdf/educator_arabic.pdf"
          download
          className="educator-mobilescreen-arabic-download"
        >
          <DownloadIcon />
          <span className="educator-mobilescreen-arabic-download-pdf-text">
            PDF
          </span>{" "}
          تحميل
        </a>
      </div>
    </div>
  );
};

export default EducatorKitArabicMobileScreen;
